export const parseCurl = (curlText) => {
  const result = {
    method: "GET",
    url: "",
    headers: [],
    body: "",
    bodyType: "json", // 👈 NEW: 'json' or 'form'
    form: [],
  };

  const cleaned = curlText.replace(/\\\n/g, " ");
  const tokens = cleaned.match(/(?:[^\s"']+|"[^"]*"|'[^']*')+/g) || [];

  let i = 0;
  while (i < tokens.length) {
    const token = tokens[i];

    if (token === "curl") {
      i++;
      continue;
    }

    if (token === "-X" || token === "--request") {
      result.method = tokens[++i].replace(/['"]/g, "").toUpperCase();
    } else if (token === "-H" || token === "--header") {
      const header = tokens[++i].replace(/^['"]|['"]$/g, "");
      result.headers.push(header);
    } else if (
      token === "--data" ||
      token === "--data-raw" ||
      token === "--data-binary"
    ) {
      let data = tokens[++i];
      if (
        (data.startsWith("'") && data.endsWith("'")) ||
        (data.startsWith('"') && data.endsWith('"'))
      ) {
        data = data.slice(1, -1);
      }

      result.body = data;

      try {
        const parsed = JSON.parse(data);
        result.bodyType = "json"; // valid JSON
      } catch (err) {
        if (data.includes("=") && data.includes("&")) {
          // likely form data
          result.bodyType = "form";
          result.form = data.split("&").map((pair) => {
            const [key, ...rest] = pair.split("=");
            return { key, value: rest.join("=") };
          });
        }
      }

      if (result.method === "GET") {
        result.method = "POST";
      }
    } else if (token === "-F" || token === "--form") {
      result.bodyType = "form";
      const field = tokens[++i].replace(/^['"]|['"]$/g, "");
      const [key, ...rest] = field.split("=");
      result.form.push({ key, value: rest.join("=") });

      if (result.method === "GET") {
        result.method = "POST";
      }
    } else if (!token.startsWith("-") && !result.url) {
      result.url = token.replace(/^['"]|['"]$/g, "");
    }

    i++;
  }

  return result;
};
